import AutomatedTools from "features/document-page/styles/AutomatedTools.styled";
import StyledInfoCard from "features/document-page/components/info/styles/StyledInfoCard.styled";
import StyledVisaBanner from "features/shared/components/banners/visa-banner/styles/StyledVisaBanner.styled";
import { QuietButton } from "features/shared/components/buttons/QuietButton.styled";
import styled from "styled-components";

interface StyledBasicDocumentPageProps {
  // the info card sits below the banner when there is one, and beside the
  // tools card (its original spot) when there isn't - grid-template-areas
  // can't leave "banner" empty and still put info in row 1, so the shape
  // itself has to switch instead of just letting the banner area go unused
  $hasVisaBanner: boolean;
}

const StyledBasicDocumentPage = styled.div<StyledBasicDocumentPageProps>`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-areas: ${({ $hasVisaBanner }) =>
    $hasVisaBanner
      ? `
    "tools banner"
    ".     info"
  `
      : `"tools info"`};
  gap: 16px;

  ${AutomatedTools} {
    grid-area: tools;
  }

  ${StyledVisaBanner} {
    grid-area: banner;
  }

  ${StyledInfoCard} {
    grid-area: info;
  }

  .manual-info {
    margin-bottom: 24px;
    text-align: center;
  }

  ${QuietButton} {
    width: 100%;
  }

  @media all and (max-width: ${({ theme }) => theme.mobileBreakingPoint}) {
    display: block;

    ${StyledVisaBanner}, ${AutomatedTools} {
      margin-bottom: 24px;
    }
  }
`;

export default StyledBasicDocumentPage;
